import { useCallback, useEffect } from 'react';
import scriptjs from 'scriptjs';

import './styles/index.module.scss';

const RECAPTCHA_SITE_KEY = '6LdW59olAAAAAC1ijbYjJpyBISQdpfzBUO0GJcp9';
const API_URL = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;

export const useReCaptchaV3 = (initialize = false, action = 'submit') => {
	const execute = useCallback(() => {
		return new Promise<string>((resolve, reject) => {
			try {
				if (window.grecaptcha) {
					window.grecaptcha.ready(function () {
						// @ts-ignore
						window.grecaptcha.execute(RECAPTCHA_SITE_KEY, { action }).then((token) => {
							resolve(token);
						});
					});
				} else {
					resolve('Not available');
				}
			} catch (error) {
				reject(error);
			}
		});
	}, [action]);

	useEffect(() => {
		if (initialize) {
			scriptjs(API_URL);
		}
	}, [initialize]);

	return execute;
};
